"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const date_fns_1 = require("date-fns");
const Flex_1 = tslib_1.__importDefault(require("../Elements/Flex"));
const styles_1 = require("../../styles");
const Card_1 = require("../Card");
const calendarUtils_1 = require("./helpers/calendarUtils");
const Header_1 = tslib_1.__importDefault(require("./Header"));
const defaultProps = {
    weekStartsOn: calendarUtils_1.WeekStartsOn.Mon,
    highlightsOn: [calendarUtils_1.WeekStartsOn.Sat, calendarUtils_1.WeekStartsOn.Sun],
    canSelectPastDates: true,
};
const initialState = {};
const Container = (0, styled_components_1.default)(Card_1.CardContainer) `
  min-width: fit-content;
  padding: 1rem;
`;
const Day = (0, styled_components_1.default)(Flex_1.default) `
  color: ${props => (!props.isSameMonth ? 'gray !important' : 'inherit')};
  color: ${props => (props.isSelected ? 'blue' : props.isToday ? 'red' : 'inherit')};
  min-width: 2.3rem;
  min-height: 2.3rem;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: ${styles_1.Colors.Primary};
    font-weight: bold;
    text-decoration: underline;
  }
`;
class Calendar extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.handleNextMonth = () => {
            const { value } = this.state;
            this.setState({ value: (0, date_fns_1.addMonths)(value, 1) });
        };
        this.handlePrevMonth = () => {
            const { value } = this.state;
            this.setState({ value: (0, date_fns_1.subMonths)(value, 1) });
        };
        this.state = {
            value: props.value || new Date(),
        };
    }
    render() {
        const { value } = this.state;
        const { weekStartsOn, onDateChange, canSelectPastDates, highlightsOn } = this.props;
        const calendar = (0, calendarUtils_1.calendarBuilder)(value, { weekStartsOn });
        return (react_1.default.createElement(Container, { flexDirection: "column" },
            react_1.default.createElement(Header_1.default, { onPrevClick: this.handlePrevMonth, onNextClick: this.handleNextMonth, value: value, weekStartsOn: weekStartsOn, highlightsOn: highlightsOn }),
            calendar.map((week, weekIndex) => (react_1.default.createElement(Flex_1.default, { key: `week-${weekIndex}` }, week.map(day => {
                const handleDateChange = () => {
                    const canSelect = (0, calendarUtils_1.isBeforeToday)(day) ? canSelectPastDates : true;
                    if (onDateChange && canSelect) {
                        onDateChange(day);
                    }
                };
                return (react_1.default.createElement(Day, { onClick: handleDateChange, flex: "1", key: day.toDateString(), isSameMonth: (0, date_fns_1.isSameMonth)(day, value), isToday: (0, date_fns_1.isToday)(day), isSelected: this.props.value ? (0, date_fns_1.isSameDay)(this.props.value, day) : false }, day.getDate()));
            }))))));
    }
}
exports.default = Calendar;
Calendar.defaultProps = defaultProps;
